import { useMemo } from 'react'
import { useParams } from 'react-router'
import ModalCEVariantValue from './ModalCEVariantValue'
import VariantValuesSortButton from './VariantValuesSortButton'
import { VariantValueModelTypeExtended } from './types'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { EditRowNotLink, DeleteRow } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import ModalDeleteVariantValue from './ModalDeleteVariantValue'

interface VariantValuesProps extends ComponentWithPermissions { }

const VariantValues: React.FC<VariantValuesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('values', 'Valores'),
        newText: t('newValue', 'Nuevo valor'),
    }

    return (
        <BaseScreenTable TableComponent={TableVariantValues} CreateModalComponent={ModalCEVariantValue} EditModalComponent={ModalCEVariantValue} DeleteModalComponent={ModalDeleteVariantValue} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableVariantValuesProps extends TableComponentProps { }

const TableVariantValues: React.FC<TableVariantValuesProps> = ({ setTableInstance, userPermissions, setOpened, tableInstance }) => {
    const { t } = useTwinTranslation()
    const { VariantId } = useParams()
    const extraWhereParams = { 'VariantGroupId': VariantId ? parseInt(VariantId) : null }
    const columns: ColumnTableSchema<VariantValueModelTypeExtended> = [
        {
            id: 'order',
            dataKey: 'order',
            label: t('order', 'Orden'),
            sortable: true,
            width: 100
        },
        {
            id: 'ref_code',
            dataKey: 'ref_code',
            label: t('code', 'Código'),
            sortable: true,
            width: 100
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    const children = useMemo(() => <VariantValuesSortButton tableInstance={tableInstance} userPermissions={userPermissions} />, [tableInstance, userPermissions])
    return (
        <TwinTable columns={columns} name='variantValues' extraWhereParams={extraWhereParams} getDataFrom='/api/app/product/productVariant/variantValue/getAllVariantValues' setTableInstance={setTableInstance} defaultOrder={{ defaultOrderField: 'order', order: 'asc' }} hideLoadFiltersButton={true} >{children}</TwinTable>
    )

}

export default VariantValues